import domain from '@framework/config/domain';
import env from '@framework/env/env';

const config = {
  name: 'Users',
  code: 'users' as const,
  supportEmail: env('FINSIGHT_WEB___SUPPORT__EMAIL'),
  hostname: `${ domain.usersDomain }`,
  ga: {
    trackingId: env('GA__TRACKING_ID_DEALROADSHOW'),
  },
  gtm: {
    trackingId: env('FRONTEND___GOOGLE_TAG_MANAGER__TENANT_DEALROADSHOW__GTM_ID'),
  },
  api: {
    external: `${ domain.protocol }//${ domain.usersDomain }`,
    internal: env('USERS__HOSTNAME_INTERNAL'),
  },
  featureToggle: {},
};

export default config;
